module.exports = __webpack_public_path__ + "static/404_3-d4a780cbc6105727e555f74a67c23c2f.png";